module.exports = __webpack_public_path__ + "img/em-energymonitor-studies-01.bacb3305.webp";